module.exports = __webpack_public_path__ + "static/media/ic-chevron-right.ecf2c156.svg";